import { render, staticRenderFns } from "./PagesDefaultHeaderModuleBhcpf.vue?vue&type=template&id=1331a7ec&"
import script from "./PagesDefaultHeaderModuleBhcpf.vue?vue&type=script&lang=js&"
export * from "./PagesDefaultHeaderModuleBhcpf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
